import { render, staticRenderFns } from "./GrayUser.vue?vue&type=template&id=5dd9f8c2&scoped=true"
import script from "./GrayUser.vue?vue&type=script&lang=js"
export * from "./GrayUser.vue?vue&type=script&lang=js"
import style0 from "./GrayUser.vue?vue&type=style&index=0&id=5dd9f8c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd9f8c2",
  null
  
)

export default component.exports